import { BaseSettingsClient, AppSettings } from "@core/types";
import { Config } from "../config";

type Parhato2AppSettings = {
  app: AppSettings;
};

class SettingsClient extends BaseSettingsClient {
  async getSettings() {
    const { data: settings } = await this.instance.get<Parhato2AppSettings>("/wp-json/parhato-api/v1/settings");

    return { ...Config, ...settings?.app };
  }
}

export default SettingsClient;
